/**
 * Check whether an URL is external
 * @param url - Url to test
 */
export function isExternalUrl(url: string): boolean {
  return /^(https?:\/\/|mailto:|tel:)/.test(url);
}
